var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.8556 51.0003C97.8556 25.1223 76.8774 4.14404 50.9994 4.14404C25.1214 4.14404 4.14313 25.1223 4.14313 51.0003C4.14313 76.8783 25.1214 97.8566 50.9994 97.8566C76.8774 97.8566 97.8556 76.8783 97.8556 51.0003Z",
    fill: "url(#paint0_linear_509_7072)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8556 51.0003C97.8556 25.1223 76.8774 4.14404 50.9994 4.14404C25.1214 4.14404 4.14313 25.1223 4.14313 51.0003C4.14313 76.8783 25.1214 97.8566 50.9994 97.8566C76.8774 97.8566 97.8556 76.8783 97.8556 51.0003Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2329 39.7305L45.6939 62.2695L34.4244 51",
    stroke: "#1E1E1E",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_509_7072",
    x1: 50.9994,
    y1: 4.14404,
    x2: 50.9994,
    y2: 97.8566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987EF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E36DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.b1186550dfec58269c88a190bb7efd03.svg";
export { ForwardRef as ReactComponent };